import module from 'usuarios/module.js'

const schema = {
  activo: 'boolean',
}

export class UsuariosService {
  constructor ($http) {
    this.$http = $http
  }

  get (contador, limite, q = '', todos = null, usuarioId) {
    return this.$http.get('/api/usuarios', {
      params: {
        contador,
        limite,
        q,
        todos,
        usuarioId,
      },
      schema,
    })
  }

  post (data) {
    return this.$http.post('/api/usuarios', data, {schema})
  }
}

module.service('Usuarios', UsuariosService)



// WEBPACK FOOTER //
// ./src/usuarios/services/Usuarios.js